import type { FC } from 'react';

import './dot-loader.scss';
import { cn } from '@/app/_shared/utils/tw-cn';

interface DotLoaderProps {
  className?: string;
}

/**
 * NDS 나오기 전까지 임시로 사용하는 DotLoader loading 컴포넌트
 */
const DotLoader: FC<DotLoaderProps> = ({ className }) => {
  return (
    <div className={cn('container !max-w-pc-size', className)}>
      <div className="dot" />
      <div className="dot" />
      <div className="dot" />
    </div>
  );
};

export default DotLoader;
